import styles from "../../../GooglePerformanceMax.module.scss"

export const RequiredMark = () => {
    return <span className={styles.requiredMark}>*</span>
}